document.querySelectorAll('.product-layout--auvrixa').forEach((section) => {
  const mainImage = section.querySelector('.product-main-image');
  const thumbs = section.querySelectorAll('.product-thumb');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.alt = thumb.dataset.imageAlt || '';
      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });
});

document.querySelectorAll('.product-layout--auvrixa').forEach((section) => {
  const form = section.querySelector('.auvrixa-product-form');
  if (!form) return;
  const price = section.querySelector('[data-product-price]');
  const compare = section.querySelector('[data-product-compare]');
  const saving = section.querySelector('[data-product-saving]');
  const addButton = form.querySelector('.product-add-button');
  const addLabel = form.querySelector('[data-add-label]');
  form.querySelectorAll('.bundle-card-input').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      if (price) price.textContent = input.dataset.price || '';
      if (compare) {
        const comparePrice = input.dataset.comparePrice || '';
        compare.textContent = comparePrice;
        compare.hidden = !comparePrice;
      }
      if (saving) {
        const savingAmount = input.dataset.saving || '';
        saving.textContent = savingAmount ? 'SAVE ' + savingAmount : '';
        saving.hidden = !savingAmount;
      }
      const available = input.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to bag' : 'Sold out';
    });
  });
});
